"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectWithoutProperties"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = require("styled-components");

var _styles = require("./styles");

var _Tab = require("./Tab");

var _Tabs = _interopRequireDefault(require("./Tabs.sizes"));

var _excluded = ["size", "data", "onChange", "theme"];

var Tabs = function Tabs(_ref) {
  var size = _ref.size,
      data = _ref.data,
      onChange = _ref.onChange,
      theme = _ref.theme,
      rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);

  var _useState = (0, _react.useState)(data[0].id),
      _useState2 = (0, _slicedToArray2.default)(_useState, 2),
      activeTabId = _useState2[0],
      setActiveTabId = _useState2[1];

  var _useState3 = (0, _react.useState)(0),
      _useState4 = (0, _slicedToArray2.default)(_useState3, 2),
      tabListBarWidth = _useState4[0],
      setTabListBarWidth = _useState4[1];

  var _useState5 = (0, _react.useState)(0),
      _useState6 = (0, _slicedToArray2.default)(_useState5, 2),
      tabListBarPosition = _useState6[0],
      setTabListBarPosition = _useState6[1];

  var TabsSize = (0, _Tabs.default)(theme)[size];
  var tabRefs = (0, _react.useRef)([]);

  function handleClick(tabId, index) {
    setActiveTabId(tabId);
    setPositionAndWidth(index);
  }

  function setPositionAndWidth(index) {
    setTabListBarWidth(tabRefs.current[index].offsetWidth);
    setTabListBarPosition(tabRefs.current[index].offsetLeft);
  }

  (0, _react.useEffect)(function () {
    var tab = data.find(function (tab) {
      return tab.selected === true;
    });
    var index = data.findIndex(function (tab) {
      return tab.selected === true;
    });

    if (tab) {
      setActiveTabId(tab.id);
      setPositionAndWidth(index);
    }
  }, [data]);
  return /*#__PURE__*/_react.default.createElement(_styles.Wrapper, rest, /*#__PURE__*/_react.default.createElement(_styles.TabListWrapper, {
    size: TabsSize
  }, data.map(function (tab, index) {
    return /*#__PURE__*/_react.default.createElement(_Tab.Tab, {
      ref: function ref(element) {
        return tabRefs.current.splice(index, 1, element);
      },
      key: tab.id,
      size: TabsSize,
      onClick: function onClick(e) {
        handleClick(tab.id, index);
        onChange(e, tab);
      },
      active: activeTabId === tab.id
    }, tab.label);
  }), /*#__PURE__*/_react.default.createElement(_styles.TabListBar, {
    width: tabListBarWidth,
    position: tabListBarPosition
  })), /*#__PURE__*/_react.default.createElement(_styles.TabContentWrapper, null, data.map(function (tab) {
    return /*#__PURE__*/_react.default.createElement(_styles.TabContentItem, {
      key: tab.id,
      id: tab.id,
      size: TabsSize,
      active: activeTabId === tab.id
    }, tab.content);
  })));
};

Tabs.defaultProps = {
  size: 'sm',
  full: false,
  onChange: function onChange() {}
};

var _default = (0, _styledComponents.withTheme)(Tabs);

exports.default = _default;